import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

export default function ProtectedEmployeeRoute() {
  const token = localStorage.getItem('tester_token');

  if (!token) {
    return <Navigate to="/mitarbeiter/login" replace />;
  }

  return <Outlet />;
}

